import {createReducer, on} from '@ngrx/store';
import * as Actions from '../actions/user.actions';

export interface State {
    isPending: boolean;
}

export const initialState: State = {
    isPending: false
};

export const reducer = createReducer(
    initialState,

    // Request Password Reset
    on(Actions.requestReset, state => ({...state, isPending: true})),
    on(Actions.requestResetSuccess, state => ({...state, isPending: false})),
    on(Actions.requestResetFailure, state => ({...state, isPending: false})),

    on(Actions.reset, state => ({...state, isPending: true})),
    on(Actions.resetSuccess, state => ({...state, isPending: false})),
    on(Actions.resetFailure, state => ({...state, isPending: false}))
);

export const getIsPending = (state: State) => state.isPending;
